<div class="tw-bg-white tw-rounded tw-shadow-lg tw-max-w-md tw-w-full">
  <div class="tw-px-3 tw-py-2 tw-border-b tw-border-gray-200">
    <h3 class="tw-text-base tw-font-semibold tw-text-gray-900">Add Comment</h3>
  </div>
  <div class="tw-p-3">
    <ngx-editor [message]="commentContent" [height]="150" [showMenuBar]="true" [placeholder]="'Enter your comment...'" (valueChange)="commentContent = $event"></ngx-editor>
  </div>
  <div class="tw-px-3 tw-py-2 tw-border-t tw-border-gray-200 tw-flex tw-justify-end tw-gap-2">
    <button
      class="tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-text-gray-700 tw-bg-white tw-border tw-border-gray-300 tw-rounded hover:tw-bg-gray-50 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-offset-2 focus:tw-ring-blue-500"
      (click)="cancel()"
    >
      Cancel
    </button>
    <button
      class="tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-text-white tw-bg-blue-600 tw-border tw-border-transparent tw-rounded hover:tw-bg-blue-700 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-offset-2 focus:tw-ring-blue-500"
      (click)="save()"
    >
      Save
    </button>
  </div>
</div>
